var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PricingTierEditorCore } from '../PricingTierEditor';
export function PricingTierEditor(props) {
    return React.createElement(PricingTierEditorCore, __assign({}, props));
}
export { useTierLogic } from '../hooks/useTierLogic';



//////////////////
// WEBPACK FOOTER
// ./src/components/PricingTier/entries/bootstrap.tsx
// module id = 1019
// module chunks = 0